import { Link } from 'react-router-dom'
import { Home, Search } from 'lucide-react'
import { Container } from '@/components/layout/Container'
import { Button } from '@/components/ui/button'
import { FadeUp } from '@/components/motion/FadeUp'
import { PATHS } from '@/routes/paths'
import { trackPostPropertyClick } from '@/lib/analytics/sellerEvents'

const CTA_IMAGE =
  'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1400&h=500&fit=crop&q=80'

export function HomeCTA({ embedded = false }: { embedded?: boolean }) {
  const panel = (
    <div
      className="relative flex h-full min-h-[300px] flex-col justify-center overflow-hidden rounded-2xl px-5 py-8 text-center text-white sm:px-6 sm:py-9 lg:min-h-0 lg:py-10"
    >
      <img
        src={CTA_IMAGE}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-linear-to-r from-primary-900/92 via-primary-800/88 to-primary-700/82" />

      <div className="relative z-10 mx-auto w-full max-w-md">
        <h2 className="font-display text-lg font-bold text-white sm:text-xl lg:text-[22px]">
          Ready to Find Your Dream Home?
        </h2>
        <p className="mt-2 text-sm text-white/90">
          List your property for free or explore thousands of verified listings across Gujarat.
        </p>
        <div className="mt-5 flex flex-col items-center justify-center gap-2.5 sm:flex-row">
          <Button
            asChild
            size="lg"
            className="h-10 bg-white text-sm text-primary-600 shadow-none hover:bg-primary-50 sm:h-11"
          >
            <Link to={PATHS.addProperty} onClick={() => trackPostPropertyClick('home_cta')}>
              <Home className="h-4 w-4" /> Post Property Free
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            className="h-10 border-2 border-white/90 bg-transparent text-sm text-white hover:bg-white/10 sm:h-11"
          >
            <Link to={PATHS.properties}>
              <Search className="h-4 w-4" /> Browse Properties
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )

  if (embedded) return panel

  return (
    <section className="py-9 sm:py-11">
      <Container>
        <FadeUp>{panel}</FadeUp>
      </Container>
    </section>
  )
}
